module.exports = __webpack_public_path__ + "img/turk3.21efc6d1.jpg";